import {Button, Popconfirm, Space, Table} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import './index.scss'
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const WorkTimeTable = ({data, deleteHandle}) => {
    const navigate = useNavigate();

    const ScreenMD = useBreakpoint().md;



    const Edit = (id) => {
        navigate(`/work-time/add?editId=${id}`)
    };


    const columns = [

        {
            title: 'Время начала',
            dataIndex: 'startTime',
            render: (text) => <p>{text}</p>,
        },
        {
            title: 'Время окончания',
            dataIndex: 'endTime',
            render: (text) => <p>{text}</p>

        },

        {
            title: 'Событие',

            render: (_, record) => (
                <Space direction={ScreenMD ? 'horizontal' : 'vertical'} size={[3, 10]}>

                    <>
                        <Button size={ScreenMD ? 'middle' : 'small'} onClick={() => Edit(record._id)} type='dashed'
                                icon={<EditOutlined/>}/>

                    </>


                </Space>
            ),
        },
    ];

    return (
        <Table
            className={'office'}
            size='small'
            columns={columns}
            dataSource={data}
            rowKey={(record) => record._id}
            pagination={{responsive: true}}
        />
    );
};

export default WorkTimeTable;
